import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            最新更新
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            实时追踪全网热播电视剧的更新动态
          </p>
        </div>

        <div className="relative pl-8">
          <div className="absolute left-[11px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-6">
            {updateItems.map((item) => (
              <div key={item.id} className="relative">
                <div className="absolute -left-[25px] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="bg-background-100 rounded-xl p-4 md:p-5">
                  <span className="inline-block text-xs text-primary-500 font-semibold mb-1.5">
                    {item.time}
                  </span>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}